import script from "./AssetsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetsCard.vue?vue&type=script&setup=true&lang=js"

import "./AssetsCard.vue?vue&type=style&index=0&id=608c8fa2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-608c8fa2"]])

export default __exports__